import { Page } from "../../../components/Page";
import { Flex } from "@chakra-ui/react";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import FootPrint from "./components/FootPrint";
import { H1 } from "../../../components/text/headings";
import { useAppConfig } from "../../../context";

const EmissionsInsights = () => {
  const [searchParams] = useSearchParams();
  const detailView = searchParams.get("detailView");

  // Insights pages need every horizontal pixel for the charts, so collapse
  // the left nav on entry. The Layout itself handles collapsing on any
  // click in the main content area, so we don't need a per-page listener
  // here.
  const { setStoredSidebarState, setSidebarState } = useAppConfig();
  useEffect(() => {
    setStoredSidebarState(false);
    setSidebarState(false);
    // Run once on mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page>
      <Flex direction="column" gap={2} mx="10%">
        {!detailView && <H1>Organisation Footprint</H1>}
        <FootPrint />
      </Flex>
    </Page>
  );
};

export default EmissionsInsights;
